<template>
  <div class="packageComponentList">
    <div class="packageCode">
      <span v-if="orderType !== 'PRE-PACKAGE'">[{{ locale[orderType] }}]</span>
      {{ packageCode }} <span v-if="packageDesc">({{ packageDesc }})</span>
    </div>
    <div class="packageDatetime">{{ locale.package_createat }}: {{ createat }}</div>
    <div
      v-for="(item, index) in list"
      :key="index"
      :data-type="item.linkData.type"
      class="packageComponentItem">
      <SetLink
        :customParams="addLinkGpId"
        :linkTarget="item.linkData"
        :lang="lang" />
      <div class="preWrap">{{ item.linkText[lang] }}</div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import SetLink from '@/components/Util/SetLink.vue'

export default {
  name: 'PackageComponent',
  props: [
    'locale',
    'lang',
    'gpId',
    'packageCode',
    'packageDesc',
    'orderType',
    'packageCreateat',
    'packageService'
  ],
  components: {
    SetLink
  },
  computed: {
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm:ss'
      return `${this.dateFormat} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    createat () {
      const createat = this.packageCreateat && DateTime.fromISO(this.packageCreateat, { zone: this.timezone })
      return createat.toFormat(this.format)
    },
    addLinkGpId () {
      return { add: [{gpId: this.gpId}] }
    }
  },
  mounted () {
    if (this.packageService) {
      this.list = this.packageService
    }
  },
  data () {
    return {
      list: []
    }
  }
}
</script>
